import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

const DuplicateProperties: FunctionComponent<{ properties: any, onDuplicateProperty: any }> = (props) => {


    const { t } = useTranslation();

    const handleDuplicate = async () => {
        const listings = {
            "properties": props.properties
        }
        props.onDuplicateProperty(listings)
    };


    return (
        <button type="submit" className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 padd-10-15-mb marg-right-16 mb-3 ${props.properties.length == 0 ? "disabled" : ''}`}
            onClick={handleDuplicate}>
            {t('propertiesPage.duplicate')}
        </button>
    )
}
export default DuplicateProperties;
